

import { useCustomersReportsQuery } from '../queries/use-client-report.query'
import { useDashboardQuery } from '../queries/use-dashboard.query'
import { useSelectedSeller } from '@/modules/shared/hooks/use-selected-seller'
import { useHomeStore } from '../stores/home.store'
import { useAuthStore } from '@/modules/shared/stores/auth.store'

export function useHomeData() {
  const selectedSeller = useSelectedSeller()
  const { goalsReport, isLoadingGoalsReport } = useDashboardQuery(selectedSeller)

  const { typeDashboard: selectedTypeDashboard } = useHomeStore()
  const nivelAcesso = useAuthStore((state) => state.nivelAcesso)
  const typeDashboard = nivelAcesso === 3 && selectedTypeDashboard === 5
    ? 1
    : selectedTypeDashboard


  const { clientsReports, isLoadingCustomersReports } =
    useCustomersReportsQuery({
      typeDashboard: typeDashboard ?? 1,
      enabled: typeDashboard !== 5,
      vendedor: selectedSeller,
    })

  return {
    typeDashboard,
    goalsReport,
    isLoadingGoalsReport,
    clientsReports,
    isLoadingCustomersReports,
  }
}
